import React from "react";
import {Card, CardBody, CardImg, CardImgOverlay, CardSubtitle, CardText, CardTitle, Col, Row,} from "reactstrap";
import {Link} from "react-router-dom";
import classNames from 'classnames';
import StatusCircle from '../StatusCircle';
import {getAgeGroupDiv, getCDNImage} from "../../util/utility";
import {getEncryptedIdForBroadcaster} from '../../util/broadcast_util';
import BroadcastListViewComponent from "../BroadcastListViewComponent/BroadcastListViewComponent";

const getBroadcastType = (isRelated, broadcastDetail) => {
    if (isRelated) {
        if (broadcastDetail && broadcastDetail.hasOwnProperty("broadcast") && Array.isArray(broadcastDetail.broadcast) && broadcastDetail.broadcast.length > 0 && broadcastDetail.broadcast[0].hasOwnProperty("type")) {
            return broadcastDetail.broadcast[0].type;
        } else {
            return "offline";
        }
    } else {
        return broadcastDetail.type;
    }
};

const getBroadcastDetail = (isRelated, broadcastDetail) => {

    if (isRelated) {
        if (broadcastDetail && broadcastDetail.hasOwnProperty("broadcast") && Array.isArray(broadcastDetail.broadcast) && broadcastDetail.broadcast.length > 0 && broadcastDetail.broadcast[0].hasOwnProperty("type")) {
            return broadcastDetail.broadcast[0];
        } else {
            return null;
        }
    } else {
        return broadcastDetail;
    }
};

const getChannelImage = (isRelated, broadcastDetail) => {
    let width = 294, height = 200;
    if (isRelated) {
        width = 187;
        height = 100;
    }
    return getCDNImage(broadcastDetail.broadcaster ? broadcastDetail.broadcaster.channel_image.bucket : broadcastDetail.channel_image.bucket, broadcastDetail.broadcaster ? broadcastDetail.broadcaster.channel_image.key : broadcastDetail.channel_image.key, width, height)
}

const CardComponent = (props) => {
    const {
        index,
        isBadges,
        iconSize,
        bgColor,
        broadcastDetail,
        isRelated,
    } = props;

    let channelImage = getChannelImage(isRelated, broadcastDetail);
    return (
        <Col
            md={isRelated ? "12" : "4"}
            className={isRelated ? "pb-4 px-0 broadcast-card no-padding-right no-padding-left" : "pb-4  broadcast-card no-padding-right no-padding-left no-margin no-padding"}
            key={index && index}
        >
            <Link to={`/broadcast/${getEncryptedIdForBroadcaster(broadcastDetail && broadcastDetail.id)}`}
                  style={{textDecoration: "none"}}>

                <Card style={{border: 0, backgroundColor: bgColor}} className={classNames({
                    'broadcast-list-card': !isRelated,
                    'related-broadcasts-list-card': isRelated,
                })}>

                    <StatusCircle
                        status={broadcastDetail && broadcastDetail.broadcaster ? broadcastDetail.broadcaster.status : broadcastDetail && broadcastDetail.status}/>
                    <CardImg
                        top
                        width="100%"
                        src={channelImage}
                        alt="Card image cap"
                        className={
                            isRelated
                                ? "rounded related-broadcast-card-image"
                                : "rounded"
                        }
                    >
                    </CardImg>

                    <CardImgOverlay>
                        <div
                            className={classNames({
                                'position-absolute': true,
                                'broadcast-current-status-rectangle': true,
                                'broadcast-current-status-live': getBroadcastType(isRelated, broadcastDetail) === "live",
                                'broadcast-current-status-private': getBroadcastType(isRelated, broadcastDetail) === "private",
                                'broadcast-current-status-awaiting': getBroadcastType(isRelated, broadcastDetail) === "awaiting",
                                'broadcast-current-status-available': getBroadcastType(isRelated, broadcastDetail) === "available"
                            })}
                            style={{top: 0, right: 0}}>
                            <h5 className={"broadcast-current-status-title"}>
                                {
                                    getBroadcastType(isRelated, broadcastDetail) === "awaiting" ? "Awaiting confirmation" : getBroadcastType(isRelated, broadcastDetail)
                                }
                            </h5>
                        </div>
                    </CardImgOverlay>

                    <CardBody style={{padding: 0}}>
                        <CardTitle className="broadcast">
                            <Row>
                                <Col sm={isBadges ? "8" : "12"} className="broadcast-card-title mt-2">
                                    {broadcastDetail && isRelated ? broadcastDetail.channel_description : broadcastDetail.session_title}
                                </Col>
                                {
                                    isBadges &&
                                    (
                                    <Col sm="4" className="mt-2 float-right no-padding padding-right-10" style={{textAlign: "right"}}>
                                        <span
                                            style={{fontSize: "11px"}}
                                            className="badge badge-sm premium-badge text-white">
                                          {broadcastDetail && broadcastDetail.broadcast_type === "paid" ? "PREMIUM" : null}
                                        </span>
                                        <span
                                            style={{fontSize: "11px"}}
                                            className="ml-2 badge badge-sm text-white">
                                                {getAgeGroupDiv(broadcastDetail && broadcastDetail.age_group)}
                                        </span>
                                    </Col>
                                    )
                                }
                            </Row>
                        </CardTitle>
                        <div>
                            <Row>
                                <Col sm={iconSize}>
                                    <img
                                        src={broadcastDetail && broadcastDetail.broadcaster ? broadcastDetail.broadcaster.profile_pic : broadcastDetail.profile_pic}
                                        alt="status"
                                        className="rounded-circle"
                                        width="40"
                                        height="40"
                                    />
                                </Col>
                                <Col sm="9">
                                      <span>
                                        <CardSubtitle>
                                          {broadcastDetail && broadcastDetail.broadcaster ? broadcastDetail.broadcaster.username : broadcastDetail.username}
                                        </CardSubtitle>
                                        <BroadcastListViewComponent broadcastDetail={getBroadcastDetail(isRelated, broadcastDetail)}/>
                                      </span>
                                </Col>
                            </Row>
                        </div>
                    </CardBody>
                </Card>
            </Link>
        </Col>
    );
};

export default CardComponent;
